/* tslint:disable */

declare var Object: any;
export interface LerOperatorTypeInterface {
  "id"?: number;
  "name"?: string;
}

export class LerOperatorType implements LerOperatorTypeInterface {
  "id": number;
  "name": string;
  constructor(data?: LerOperatorTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LerOperatorType`.
   */
  public static getModelName() {
    return "LerOperatorType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LerOperatorType for dynamic purposes.
  **/
  public static factory(data: LerOperatorTypeInterface): LerOperatorType{
    return new LerOperatorType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LerOperatorType',
      plural: 'LerOperatorTypes',
      path: 'LerOperatorTypes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LerOperatorType.ts